/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setActiveSelection, updateOptionProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import AnswerImage1 from 'material/embeds/content/shared/answer/image1/image1';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : IMAGE 1 : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId, optionId }) => ({
    isValid: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['isValid'],
    isDuplicate: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['isDuplicate'],
    isSelected: embedsState.embedManagementState.contentStatus['activeSelection'].includes('option') && embedsState.embedManagementState.contentStatus['activeSelection'] === `option_${optionId}`,
    imageProvider: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['imageProvider'],
    imageID: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['imageID'],
    imageURL: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['imageURL'],
    previewImageURL: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['previewImageURL'],
    text: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['text'],
});

const mapDispatchToProps = dispatch => ({
    setActiveSelection: selection => dispatch(setActiveSelection(selection)),
    updateOptionProperty: (contentId, optionId, propertyName, value) => dispatch(updateOptionProperty(contentId, optionId, propertyName, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnswerImage1);
